import * as Sentry from '@sentry/react';
import { store } from '../store';
import { selectUser } from '../store/user';

// Fire-and-forget audit event client for the cp-companion audit API.
// Never throws into the caller — failures are swallowed and reported to Sentry.
export const trackEvent = ({
  entityType,
  entityId,
  action,
  changes,
  metadata,
  actor,
}) => {
  try {
    const currentUser = actor || selectUser(store.getState())?.data;

    const body = {
      entityType,
      entityId,
      action,
      actorType: 'user',
      actorId: currentUser?.id || null,
      actorName: currentUser?.details
        ? `${currentUser.details.name} ${currentUser.details.surname}`
        : null,
      source: 'cp-redesign',
    };

    if (changes) {
      body.changes = changes;
    }
    if (metadata) {
      body.metadata = metadata;
    }

    fetch(`${process.env.REACT_APP_COMPANION_API_URL}/api/audit/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).catch((error) => {
      Sentry.captureException(error, {
        tags: { component: 'trackEvent', event_type: 'AUDIT_EVENT_FAILED' },
        extra: { entityType, entityId, action },
      });
      console.warn('trackEvent: failed to send audit event', error);
    });
  } catch (error) {
    // Never let instrumentation break the calling code path.
    Sentry.captureException(error, {
      tags: { component: 'trackEvent', event_type: 'AUDIT_EVENT_ERROR' },
      extra: { entityType, entityId, action },
    });
    console.warn('trackEvent: unexpected error', error);
  }
};

export default trackEvent;
